export default "__VITE_ASSET__67b56534__"